import { FilterTimeFrameValue } from "server/config-api/index.js";
import type { Customer } from "server/dwhApi/customers/types.js";
import type { GetTerminalPeriodsResponse } from "server/dwhApi/terminals/models.js";
import type { Terminal } from "server/dwhApi/terminals/types.js";

export const getContaminationRate = (data?: Customer | Terminal) => {
  if (
    !data?.totalWasteWeight?.quantity ||
    !data?.totalContaminatedWasteWeight?.quantity
  ) {
    return 0;
  }

  return +(
    (data.totalContaminatedWasteWeight.quantity * 100) /
    data.totalWasteWeight.quantity
  ).toFixed(1);
};

export const getContaminationRateByOccurences = (data: Customer | Terminal) => {
  if (!data?.totalOccurrences || !data?.totalContaminatedOccurrences) {
    return 0;
  }

  return +(
    (data.totalContaminatedOccurrences * 100) /
    data.totalOccurrences
  ).toFixed(1);
};

export const getDataWithCurrentMonth = ({
  periodData,
  period,
}: {
  periodData?: GetTerminalPeriodsResponse;
  period: FilterTimeFrameValue;
}) => {
  const data = [...(periodData?.periods || [])];

  const currentMonth = data[data.length - 1];
  if (currentMonth) {
    const { totalOccurrences } = currentMonth.terminal;

    if (totalOccurrences > 0) {
      if (period === FilterTimeFrameValue.Last12Months && data.length > 12) {
        data.shift();
      }
    } else {
      data.pop();
    }
  }

  return data;
};
